import { render, staticRenderFns } from "./EditarRecordatorio.vue?vue&type=template&id=8f9678b6&scoped=true"
import script from "./EditarRecordatorio.vue?vue&type=script&lang=js"
export * from "./EditarRecordatorio.vue?vue&type=script&lang=js"
import style0 from "./EditarRecordatorio.vue?vue&type=style&index=0&id=8f9678b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9678b6",
  null
  
)

export default component.exports